import { Box, Button, InlineStack, Stack, Text } from '@customerio/pluma-components/react';
import * as styles from './sheet-callout.css';

type SheetCalloutProps = {
  summary: string;
  description: string;
  actionLabel: string;
  onAction?: () => void;
};

export function SheetCallout({ summary, description, actionLabel, onAction }: SheetCalloutProps) {
  return (
    <Box className={styles.callout} p="200" backgroundColor="overlay-tint">
      <InlineStack gap="200" alignBlock="center" alignInline="space-between">
        <Stack gap="025">
          <Text size="sm" weight="semibold">
            {summary}
          </Text>
          <Text size="xs" color="secondary">
            {description}
          </Text>
        </Stack>
        {/* Hidden until the action has somewhere to go, so it never reads as a working button. */}
        {onAction == null ? null : (
          <Button variant="secondary" size="sm" onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </InlineStack>
    </Box>
  );
}
